// extracted by mini-css-extract-plugin
module.exports = {"formatButtonContainer":"styles_formatButtonContainer__3z0vV"};